export default "__VITE_ASSET__4a526692__"